'use client';

import { useCallback } from 'react';
import { BN } from '@drift-labs/sdk';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { notify } from 'src/utils/notifications';
import { useGetTxParams } from '../transactions/useGetTxParams';

interface RequestInsuranceFundUnstakeOptions {
	displayAmount: string;
	withdrawalDate: string;
	amount: BN;
	marketIndex: number;
}

export const useRequestInsuranceFundUnstake = () => {
	const driftClient = useDriftStore((s) => s.driftClient.client);
	const getTxParams = useGetTxParams();

	const requestInsuranceFundUnstake = useCallback(
		async (opts: RequestInsuranceFundUnstakeOptions): Promise<boolean> => {
			if (!driftClient) return false;

			const toastId = `request-unstake-from-if-${opts.marketIndex}`;

			notify({
				id: toastId,
				type: 'awaiting_wallet_confirmation',
				showUntilCancelled: true,
			});

			try {
				const _txid = await driftClient?.requestRemoveInsuranceFundStake(
					opts.marketIndex,
					opts.amount,
					getTxParams()
				);

				notify({
					id: toastId,
					type: 'success',
					message: 'Requested unstake.',
					showUntilCancelled: false,
				});

				return true;
			} catch (err: any) {
				console.log(err);
				notify({
					id: toastId,
					type: 'error',
					message: 'Failed to request unstake.',
					showUntilCancelled: false,
				});
				return false;
			}
		},
		[driftClient, getTxParams]
	);

	return { requestInsuranceFundUnstake };
};
